import React from "react"
import Passwords from "@views/features/password-management"
import SEO from "@components/SEO"

const IndexPage = () => (
  <div>
    <SEO
      title="EngineID - Single Sign-On"
      keywords={[
        `engineid`,
        `security`,
        `login fatigue`,
        `password fatigue`,
        `consolidate apps`,,
        `cloud`,
        `password`,
        `passwords`,
        `password management`,
        `secrets`,
        `identity management`,
        `access management`,
      ]}
    />
    <Passwords />
  </div>
)

export default IndexPage
